import { render } from "./tasksStatuses.vue?vue&type=template&id=3ceb96bb&scoped=true"
import script from "./tasksStatuses.vue?vue&type=script&lang=js"
export * from "./tasksStatuses.vue?vue&type=script&lang=js"

import "./tasksStatuses.vue?vue&type=style&index=0&id=3ceb96bb&lang=less&scoped=true"
import "./tasksStatuses.vue?vue&type=style&index=1&id=3ceb96bb&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ceb96bb"]])

export default __exports__